import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const DownArrowIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path d="M18 13L12 19L6 13M12 18.5V5" stroke="currentColor" />
    </SvgIcon>
  )
}
